function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 61.48 37.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M57 0H4.45A4.47 4.47 0 000 4.45v28.6a4.47 4.47 0 004.45 4.45H57a4.47 4.47 0 004.47-4.45V4.45A4.47 4.47 0 0057 0zm3 33.05a3 3 0 01-3 3H4.45a3 3 0 01-3-3V4.45a3 3 0 013-2.95H57a3 3 0 013 3z",
  fill: "#80868b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57 1.5H4.45a3 3 0 00-3 3v28.6a3 3 0 003 3H57a3 3 0 003-3V4.45a3 3 0 00-3-2.95z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.52 19.54v5.22h-1.66V11.87h4.39A4 4 0 0135.1 13a3.72 3.72 0 01.18 5.26l-.18.19a4 4 0 01-2.85 1.1zm0-6.09V18h2.77a2.2 2.2 0 001.64-.66 2.27 2.27 0 00-1.64-3.84zM40.1 15.65a4.14 4.14 0 012.9 1 3.48 3.48 0 011.06 2.69v5.44h-1.58v-1.25h-.08a3.15 3.15 0 01-2.73 1.52 3.54 3.54 0 01-2.44-.87 2.72 2.72 0 01-1-2.16 2.62 2.62 0 011-2.18A4.48 4.48 0 0140 19a4.86 4.86 0 012.43.54v-.34a1.85 1.85 0 00-.68-1.47 2.31 2.31 0 00-1.6-.6A2.52 2.52 0 0038 18.3l-1.46-.92a4.06 4.06 0 013.56-1.73zM38 22.06a1.29 1.29 0 00.55 1.08 2 2 0 001.28.43 2.68 2.68 0 001.87-.77 2.47 2.47 0 00.78-1.8 3.34 3.34 0 00-2.16-.61 2.8 2.8 0 00-1.68.48 1.44 1.44 0 00-.64 1.19zM53.15 15.94l-5.53 12.71h-1.71L48 24.2l-3.63-8.26h1.8l2.63 6.34 2.56-6.34z",
  fill: "#5f6368"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.82 18.41a9.39 9.39 0 00-.12-1.5h-7v2.85h4A3.42 3.42 0 0118.23 22v1.85h2.39a7.23 7.23 0 002.2-5.44z",
  fill: "#4285f4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.71 25.65a7.1 7.1 0 004.91-1.79L18.23 22a4.49 4.49 0 01-6.68-2.35H9.1v1.91a7.39 7.39 0 006.61 4.09z",
  fill: "#34a853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.55 19.66a4.42 4.42 0 010-2.83v-1.91H9.1a7.35 7.35 0 000 6.65z",
  fill: "#fbbc04"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.71 13.77a4 4 0 012.84 1.11l2.12-2.11a7.13 7.13 0 00-5-1.93 7.39 7.39 0 00-6.57 4.08l2.45 1.91a4.43 4.43 0 014.16-3.06z",
  fill: "#ea4335"
})));